var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('el-form',{staticClass:"form-map-main"},[_c('el-form-item',[_c('el-input',{attrs:{"placeholder":"ingrese una patente"},model:{value:(_vm.data.patent),callback:function ($$v) {_vm.$set(_vm.data, "patent", $$v)},expression:"data.patent"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }